///<amd-module name="typeahead/core/logging/ErrorLogger"/>

import {IErrorTransport} from "typeahead/core/logging/ErrorTransport";
import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";

export class ErrorLogger implements IErrorTransport {
    private transport: IErrorTransport;

    public constructor(transport: IErrorTransport) {
        this.transport = transport;
    }

    public log(error: Error, severity: Severity, origin: ProblemOrigin, additional = {}): void {
        try {
            this.transport.log(error, severity, origin, additional);
        } catch (transportError) {
            // do nothing
        }
    }
}
